import { Component, OnInit, Renderer2 } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { AuthenticationService } from "@app/core/services/ats/authentication.service";
import { UIUtil } from "@app/core/utils/ui.util";
import { NzModalService, UploadXHRArgs, NzMessageService } from "ng-zorro-antd";
import { session_keys, Authetication } from "@app/core";
import { JSEncrypt } from "jsencrypt";
import { NgxCaptchaModule } from "ngx-captcha";
import { environment } from "@env/environment";
import { ReCaptchaV3Service } from "ngx-captcha";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  role: any;
  saveLoader = false;
  isValid = true;
  emailId = "";
  errMsg;
  private _array = Array;
  isForgotPwd = true;
  mailIdValidate = false;
  siteKey = environment.captcha_site_key;
  captchaToken = null;
  popupModelForgotPwd = {
    isVisible: false,
    loading: false,
    messageText: "",
  };

  encrypt = new JSEncrypt();
  decrypt = new JSEncrypt();
  encryptedData: string;
  // decryptedData: string;

  publicKey = `
  -----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAqBQi7hZ1rU0f14jnzeAH
fyY5ElLQKJ9uCikWHmrBNF0jwplmO9Upb0nrkcBZiPHCTpBlPVytbH44v6cGw4Pr
PtyrTsI/PfHlYtmB/rTZ9zV19y+ZCrNM1faLvDqDiFP0B9Jffd9uTwlihmusDWgI
+DiV/uPbKey7YXI0+ZdWV8IN8bTPyO4aXVRg8gSiZZTqlN59Z++tP8kjR9bZCqpk
dN7UA3ULnE9tMqUnd7wA0RX/a9hVxPkMnQceGZk1hH82BtP8ONKnwjR42PYbvKEY
wQzaGOHHISwvoDB5QsqivGb48ivF04aZlBGVgPlJIsHf+ihkLwQcux3hddCUKSWT
7QIDAQAB
-----END PUBLIC KEY-----
  `;

  constructor(
    private message: NzMessageService,
    private _router: Router,
    private fb: FormBuilder,
        private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private renderer: Renderer2
  ) {
    this.renderer.addClass(document.body, "grecaptcha");


     this.route.queryParams.subscribe((params) => {
      if (params["token"]) {
        let body = {
          token: params["token"],
          username: params["email"],
        };
           

                 this.authenticationService
                   .loginPassword(body)
                   .subscribe(
                     (response) => {
                       if (!response) {
                         this.saveLoader = false;
                         this.isValid = false;
                       } else {
                         this.isValid = true;
                         const data: Authetication = {
                           email: response.user.email,
                           token: response.token,
                           userName: response.user.email,
                           is_latral:true,
                           userId: response.user.id,
                           vendor: response.user_detail.id,
                           z: "",
                           display_name:
                             response.user.first_name +
                             " " +
                             response.user.last_name,
                           designation: response.user_detail.type,
                           profile_pic: response.user.profile_pic_link,
                           is_password_expired: response.is_password_expired
                             ? response.is_password_expired
                             : false,
                           password_reset_token: response.password_reset_token
                             ? response.password_reset_token
                             : null,
                         };

                         UIUtil.savePrivateData(session_keys.private_key, data);
                         if (response && response.is_password_expired) {
                           this._router.navigate(["reset-password"]);
                         } else {
                           this._router.navigate(["./view"]);
                         }
                       }
                       this.renderer.removeClass(document.body, "grecaptcha");
                     },
                     (error) => {
                       this.saveLoader = false;
                       this.isValid = false;
                       if (error.Message.non_field_errors !== undefined) {
                         this.errMsg = error.Message.non_field_errors[0];
                       } else if (error.Message instanceof Array) {
                         this.errMsg = error.Message[0];
                       } else {
                         this.errMsg = error.Message;
                       }
                       this.renderer.removeClass(document.body, "grecaptcha");
                     },
                   );
      }
   });
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      userName: ["", [Validators.required]],
      password: ["", [Validators.required]],
    });





  }

  login() {
    // tslint:disable-next-line:forin
    for (const i in this.loginForm.controls) {
      this.loginForm.controls[i].markAsDirty();
      this.loginForm.controls[i].updateValueAndValidity();
    }
    if (this.loginForm.valid) {
      this.saveLoader = true;
      this.isValid = true;
      // call the service here....

      this.reCaptchaV3Service.execute(
        this.siteKey,
        "loginpage",
        (token) => {
          this.captchaToken = token;

          const email = this.loginForm.controls.userName.value;
          // const password =btoa(this.loginForm.controls.password.value);

          this.encrypt.setPublicKey(this.publicKey);
          const password: any = this.encrypt.encrypt(
            this.loginForm.controls.password.value
          );

          this.authenticationService
            .login(email, password, this.captchaToken)
            .subscribe(
              (response) => {
                if (!response) {
                  this.saveLoader = false;
                  this.isValid = false;
                } else {
                  this.isValid = true;
                  const data: Authetication = {
                    email: response.user.email,
                    token: response.token,
                    is_latral: false,
                    userName: response.user.email,
                    userId: response.user.id,
                    vendor: response.user_detail.id,
                    z: "",
                    display_name:
                      response.user.first_name + " " + response.user.last_name,
                    designation: response.user_detail.type,
                    profile_pic: response.user.profile_pic_link,
                    is_password_expired: response.is_password_expired
                      ? response.is_password_expired
                      : false,
                    password_reset_token: response.password_reset_token
                      ? response.password_reset_token
                      : null,
                  };

                  UIUtil.savePrivateData(session_keys.private_key, data);
                  if (response && response.is_password_expired) {
                    this._router.navigate(["reset-password"]);
                  } else {
                    this._router.navigate(["./view"]);
                  }
                }
                this.renderer.removeClass(document.body, "grecaptcha");
              },
              (error) => {
                this.saveLoader = false;
                this.isValid = false;
                if (error.Message.non_field_errors !== undefined) {
                  this.errMsg = error.Message.non_field_errors[0];
                } else if (error.Message instanceof Array) {
                  this.errMsg = error.Message[0];
                } else {
                  this.errMsg = error.Message;
                }
                this.renderer.removeClass(document.body, "grecaptcha");
              }
            );
        },
        {
          useGlobalDomain: false,
        }
      );
    }
  }

  forgotPwd() {
    this.popupModelForgotPwd.isVisible = true;
    this.isForgotPwd = true;
  }

  requestPwd() {
    if (this.emailId !== "") {
      if (!this.validateEmail(this.emailId)) {
        this.mailIdValidate = true;
        return false;
      } else {
        this.authenticationService.forgotpwd(this.emailId).subscribe(
          (response) => {
            this.isForgotPwd = false;
          },
          (err) => {
            if (err.Message.non_field_errors !== undefined) {
              this.message.warning(err.Message.non_field_errors[0]);
            } else if (err.Message instanceof Array) {
              this.message.warning(err.Message[0]);
            } else {
              this.message.warning(err.Message);
            }
          }
        );
      }
    } else {
      this.mailIdValidate = true;
    }
  }

  validateEmail(email) {
    const re =
      /^(([^<>()[\]{}'^?\\.,!|//#%*-+=&;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    return re.test(email);
  }
}
